/**
 *  瀑布流图片指令(支持自适应)
 *  继承方式：scope: false
 *  说明: 以下是使用指令的需求参数以及需求方法说明
 *  需求参数：
 *  // 请求的列表数据
 *  $scope.data.items = []
 *  $scope.childStatus = {
 *      // 图片数组的string
 *      checkString: 'DOC_PICTURELIST',
 *      // 图片数组中表示url地址的string
 *      picString: 'PERPICURL'
 *  };
 *  // 需求的第三方方法：在shareModule中的(暂不知道用处，现有数据未能展示测试)
 *  $scope.viewInfo 和 $scope.showOperFlag
 */
'use strict';
angular.module('autoPicModule', []).directive('autoPic', ['$state', '$timeout', 'mrApiService', 'modalDialog', '$window', 'trsHttpService', '$q',
    function ($state, $timeout, mrApiService, modalDialog, $window, trsHttpService, $q) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: './components/util/autoPic/autoPic.html',
            link: function (scope) {
                // 默认列表高度
                scope.status = {
                    defaultHeight: 180,
                    isShowMore: false,
                    completion: 0
                };
                // 传输对象
                scope.showData = [];
                // 展示对象
                scope.realShow = [];
                getRightForCheckPic();
                scope.picCurrentName = $state.current.name.split('.')[1];
                scope.$watch('data.items', () => {
                    scope.status.completion = 0;
                    scope.showData = typeof scope.data.items === 'string' ? JSON.parse(scope.data.items) : scope.data.items;
                    initData();
                });

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if (typeof scope.showData === 'object' && scope.showData.length > 0) {
                        dueEachStyle();
                    } else {
                        // 这个判断为了让图集模式无数据时，清空展示
                        scope.realShow = [];
                    }
                }

                /**
                 * [dueEachStyle description]处理基础显示比例的宽高
                 *
                 * @return  {[type]}  [return description]
                 */
                function dueEachStyle() {
                    const delIndex = [];
                    scope.realShow = [];
                    scope.showData.forEach((item, index) => {
                        item.showHeight = scope.status.defaultHeight;
                        if (item[scope.childStatus.checkString].length === 0) {
                            delIndex.push(index);
                        } else {
                            if (item[scope.childStatus.checkString][0].WIDTH && item[scope.childStatus.checkString][0].HEIGHT) {
                                item.showWidth = item[scope.childStatus.checkString][0].WIDTH / item[scope.childStatus.checkString][0].HEIGHT * scope.status.defaultHeight;
                                if (item.showWidth < 200) {item.showWidth = 200;} // 提供最小值
                            } else {
                                item.showWidth = 230;
                            }
                            item[scope.childStatus.checkString].forEach((picList) => {
                                picList.showHeight = scope.status.defaultHeight;
                                if (picList.WIDTH && picList.HEIGHT) {
                                    picList.showWidth = picList.WIDTH / picList.HEIGHT * scope.status.defaultHeight;
                                } else {
                                    picList.showWidth = 230;
                                }
                            });
                            scope.realShow.push(item);
                        }
                    });
                    computeList();
                    $timeout(() => {
                        if (scope.status.isShowMore) {
                            scope.status.topSet = document.getElementsByClassName('eachAutoMain')[scope.status.chooseIndex].offsetTop + scope.realShow[scope.status.chooseIndex].showHeight + 75;
                            scope.status.leftSet = document.getElementsByClassName('eachAutoMain')[scope.status.chooseIndex].offsetLeft + scope.realShow[scope.status.chooseIndex].showWidth / 2 - 15;
                        }
                    });
                }

                /**
                 * [computeList description]将图片进行计算分组
                 *
                 * @return  {[type]}  [return description]
                 */
                function computeList() {
                    const list = [[]];
                    const domWidth = document.getElementsByClassName('autoPicMain')[0].offsetWidth - 10;
                    const showMoreDom = domWidth - 33;
                    let index = 0;
                    let indexAll = 0;
                    scope.realShow.forEach((item, checkIndex) => {
                        if ((indexAll + item.showWidth / 2) > (domWidth - 10 * list[index].length)) {
                            list[index][list[index].length - 1].total = indexAll;
                            index++;
                            indexAll = item.showWidth;
                            list.push([item]);
                        } else {
                            list[index].push(item);
                            indexAll = indexAll + item.showWidth;
                            if (checkIndex === scope.realShow.length - 1) {
                                list[index][list[index].length - 1].total = indexAll;
                            }
                        }
                        let picIndex = 0;
                        let picIndexAll = 0;
                        const newlist = [[]];
                        item[scope.childStatus.checkString].forEach((picList, picCheckIndex) => {
                            if ((picIndexAll + picList.showWidth / 2) > (showMoreDom - 10 * newlist[picIndex].length)) {
                                newlist[picIndex][newlist[picIndex].length - 1].total = picIndexAll;
                                picIndex++;
                                picIndexAll = picList.showWidth;
                                newlist.push([picList]);
                            } else {
                                newlist[picIndex].push(picList);
                                picIndexAll = picIndexAll + picList.showWidth;
                                if (picCheckIndex === scope.realShow.length - 1) {
                                    newlist[picIndex][newlist[picIndex].length - 1].total = picIndexAll;
                                }
                            }
                        });
                        computeEachStyle(newlist, true);
                    });
                    computeEachStyle(list);
                }

                /**
                 * [computeEachStyle description]计算具体每一张图片的样式
                 *
                 * @param   {[type]}  list   [list description]传入处理好的list数据
                 * @param   {[type]}  check  [check description]
                 *
                 * @return  {[type]}         [return description]
                 */
                function computeEachStyle(list, check) {
                    const domWidth = document.getElementsByClassName('autoPicMain')[0].offsetWidth - scope.status.completion;
                    const showMoreDom = domWidth - 33;
                    const useDom = check ? showMoreDom : domWidth;
                    list.forEach((line, index) => {
                        const lineWidth = line[line.length - 1].total;
                        const lineHeight = useDom / lineWidth * scope.status.defaultHeight;
                        if (index !== list.length - 1 || lineWidth > useDom) {
                            line.forEach((dom) => {
                                dom.showHeight = lineHeight;
                                dom.showWidth = useDom / lineWidth * dom.showWidth - line.length / line.length * 10;
                                // if (dom.showWidth < 90){
                                //     scope.status.completion += Math.ceil(90 - dom.showWidth);
                                //     dom.showWidth = 90;
                                // }
                            });
                        }
                    });
                }

                /**
                 * [showMorePic description]展示图集详情图片
                 *
                 * @param   {[type]}  index  [index description]图集详情选择
                 *
                 * @return  {[type]}         [return description]
                 */
                scope.showMorePic = function (index) {
                    if (index === scope.status.chooseIndex) {
                        scope.status.chooseIndex = null;
                        scope.status.isShowMore = false;
                        return;
                    }
                    scope.status.isShowMore = true;
                    scope.status.chooseIndex = index;
                    scope.status.showMorePic = scope.realShow[index][scope.childStatus.checkString];
                    scope.status.topSet = document.getElementsByClassName('eachAutoMain')[index].offsetTop + scope.realShow[index].showHeight + 75;
                    scope.status.leftSet = document.getElementsByClassName('eachAutoMain')[index].offsetLeft + scope.realShow[index].showWidth / 2 - 15;
                };


                // scope.goToDetail = function(params) {
                //     var url = $state.href(scope.childStatus.url, params);
                //     window.open(url, '_blank');
                // };

                /**
                 * [throttle description]节流函数
                 *
                 * @param   {[type]}  func   [func description]
                 * @param   {[type]}  delay  [delay description]
                 *
                 * @return  {[type]}         [return description]
                 */
                var throttle = function (func, delay) {
                    var timer = null;
                    return function () {
                        var context = this;
                        var args = arguments;
                        if (!timer) {
                            timer = setTimeout(function () {
                                func.apply(context, args);
                                timer = null;
                            }, delay);
                        }
                    };
                };
                window.onresize = throttle(dueEachStyle, 500);

                /**
                 * [sortOutShared description] 整理共享人显示，为了兼容窄图，
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                scope.sortOutShared = function (item) {
                    if (scope.childStatus.isShowAtlasShared) {
                        if (scope.childStatus.isCountyFeed) {
                            item.sharedTitleShow = '供稿单位：' + (item.FROMTENANTNAME ? item.FROMTENANTNAME : '无');
                        } else {
                            item.sharedTitleShow = '共享人：' + (item.SHAREUSRTRUENAME || item.FGDAUTHOR || '无');
                        }
                    }
                };

                /**
                 * [getRightForCheckPic description] 获取查看原图权限，
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function getRightForCheckPic() {
                    if (!scope.comeFrom) {
                        return;
                    }
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'queryOperKeysOfNormalModal',
                        ModalName: '资源中心',
                        Classify: scope.comeFrom,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        angular.forEach(data, function (value, key) {
                            scope.hasCKPicRights[value.OPERNAME] = value;
                            // // if (value.OPERNAME === 'source.sharedoc.chakanyuantu') {
                            //     scope.hasRights = true;
                            // }
                        });
                        deffer.resolve();
                    });
                    return deffer.promise;
                }
                scope.showLightGallery = function (item, index) {
                    var dynamicEl = [];
                    var picsList = scope.realShow[index][scope.childStatus.checkString];
                    picsList.forEach((pic, ind) => {
                        dynamicEl[ind] = {
                            src: pic[scope.childStatus.originPicUrl],
                            thumb: pic[scope.childStatus.originPicUrl],
                            subHtml: pic.APPDESC || item.title || pic.picDesc,
                        };
                    });
                    $(this).lightGallery({
                        thumbnail: true,
                        dynamic: true,
                        dynamicEl: dynamicEl,
                        showThumbByDefault: false,
                        thumbWidth: 200,
                        thumbHeight: '200px',
                    });
                    var isInsert = false;
                    $(this).on('onSlideItemLoad.lg', function (event, index) {
                        $('.new-img-wrap .lg-add-to-personal').remove();
                        $('.new-img-wrap .lg-add-to-takedraft').remove();
                        $('.lg-toolbar .lg-check-pic').remove;
                        $('.new-img-wrap').prepend('<a class="lg-add-to-personal">添加到个人素材</a>');
                        if (scope.hasCKPicRights && (scope.hasCKPicRights['source.sharedoc.chakanyuantu'] || scope.hasCKPicRights['source.xinhuadoc.chakanyuantu']) && !isInsert) {
                            isInsert = true; // 避免多次插入dom
                            $('.lg-toolbar').append('<a class="lg-check-pic">查看原图</a>');
                        }
                        $('a.lg-check-pic').click(() => {
                            if (isInsert) {
                                var picItem = item[scope.childStatus.checkString][Number($('#lg-counter-current').text()) - 1];
                                var url = picItem.urlM || picItem.SRCPICURL; // 新华社和共享稿库查看原图
                                if (index === Number($('#lg-counter-current').text()) - 1) {
                                    window.open(url);
                                }
                            }
                            
                        });

                        // 共享稿库和新华社有取稿按钮
                        if (scope.picCurrentName === 'resourcectrl' || scope.picCurrentName === 'networksource') {
                            $('.new-img-wrap').prepend('<a class="lg-add-to-takedraft">取稿</a>');
                        }
                        $('a.lg-add-to-personal').click(() => {
                            addToPersonal(item, index, Number($('#lg-counter-current').text()) - 1);
                        });
                        $('a.lg-add-to-takedraft').click(() => {
                            // 在点击取稿得时候 把当前稿件存进scope.data.selectedArray，执行完取稿操作之后 马上 将当前稿件从scope.data.selectedArray 释放出来, 避免影响单选多选操作
                            scope.data.selectedArray.push(item);
                            var index = scope.data.selectedArray.indexOf(item);
                            scope.openTakeDraftModal();
                            scope.data.selectedArray.splice(index, 1);
                        });
                    });

                };

                /**
                * [addToPersonal description]
                * @param   {[type]}  item   [text description]
                * @param   {[type]}  index  [index description]
                * @param   {[type]}  text   [text description]
                *
                * @return  {[type]}         [return description]
                */
                function addToPersonal(item, index, text) {
                    var descArr = item[scope.childStatus.checkString];
                    var newFileName = descArr[text][scope.childStatus.picString].split('/');
                    mrApiService.addToPersonel(
                        {
                            mrType: 'personal',
                            mainResourceType: '0',
                            fileName: newFileName[newFileName.length - 1],
                            tempUrl: descArr[text][scope.childStatus.picString]
                        }
                    )
                        .then(function (data) {
                            if (data.code === '200') {
                                modalDialog.alertType('添加成功', '', 'success', false);
                                $window.document.getSelection().collapse($window.document, 1);
                            } else {
                                modalDialog.alertType('', data.msg, 'error', false);
                            }
                        });


                }

            }
        };
    }
]);
